import {useCallback, useEffect, useRef} from 'react';

import {AbortSignalManager} from './abort-signal-manager';

export const useAbortSignal = (timeout?: number) => {
    const abortSignalManagerRef = useRef(new AbortSignalManager(timeout));

    useEffect(() => {
        const abortSignalManager = abortSignalManagerRef.current;
        return () => {
            if (!abortSignalManager.isAborted()) {
                abortSignalManager.abort();
            }
        };
    }, []);

    const createAbortSignal = useCallback(
        () => abortSignalManagerRef.current.createAbortSignal(),
        [],
    );

    const abort = useCallback(() => abortSignalManagerRef.current.abort(), []);

    return {createAbortSignal, abort};
};
